import { Warehouse } from "@secondcloset/types";
import { stringify } from "query-string";
import API from "../../../lib/api.deprecated";

import { PaginatedData, PaginationOptions } from "../common/pagination";

type Return = Warehouse.Return;

export type UpdateReturnBody = {
  id: string;
  status?: string;
  reship_external_order_number?: string;
  external_notes?: string;
};
export interface ReturnQuery {
  limit?: string;
  search?: string;
  status?: string;
  type?: string;
  external_order_number?: string;
  organization_id?: string;
  tab?: string;
}

export const fetchReturns = async (query: PaginationOptions & ReturnQuery): Promise<PaginatedData<Return>> => {
  const api = new API("november");
  const url = `/returns?${stringify(query || {})}`;
  const res = await api.get(url);
  return res?.data as PaginatedData<Return>;
};

export const fetchReturnDetails = async (id: string): Promise<Return> => {
  const api = new API("november");
  const url = `/returns/${id}`;
  const response = await api.get(url);
  return response?.data as Return;
};

export const updateReturn = async (body: UpdateReturnBody): Promise<Return> => {
  const api = new API("november");
  const url = `integrations/update-return/${body.id}`;
  const response = await api.patch(url, body);
  return response?.data as Return;
};
